import React from 'react';

/**
 * ErrorBoundary — surfaces the actual error message instead of just
 * "An error occurred in <X> component". Used to debug render crashes.
 */
export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null, info: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    this.setState({ info });
    console.error('ErrorBoundary caught:', error, info);
  }

  render() {
    if (this.state.error) {
      return (
        <div style={{
          padding: '24px',
          fontFamily: 'monospace',
          background: '#1a0000',
          color: '#ff8080',
          minHeight: '100vh',
        }}>
          <h2 style={{ margin: 0, color: '#ff4040' }}>RENDER ERROR</h2>
          <pre style={{
            whiteSpace: 'pre-wrap',
            marginTop: 12,
            background: '#000',
            padding: 12,
            borderRadius: 4,
            fontSize: 12,
          }}>
            {String(this.state.error.stack || this.state.error.message)}
          </pre>
        </div>
      );
    }
    return this.props.children;
  }
}
